import React from 'react';
import styled from 'styled-components';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '2560px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 102px;
  margin-top: 60px;
  width: 1140px;
  @media only screen and ${device.tablet} {
    padding: unset;
    width: 343px;
    margin-top: unset;
    flex-direction: column;
    gap: 30px;
    padding-bottom: 50px;
  }
  @media only screen and ${device.desktop} {
    padding-left: none;
    justify-content: center;
    justify-self: center;
    display: flex;
    width: 80%;
    gap: 100px;
  }
`;
const TitleHero = styled.div`
  font-family: Inter;
  font-weight: 700;
  font-size: 64px;
  color: #151515;
  @media only screen and ${device.tablet} {
    font-size: 36px;
    text-align: left;
  }
`;
const ContentHero = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 18px;
  max-width: 480px;
  text-align: left;
  color: #737373;
  @media only screen and ${device.tablet} {
    max-width: 340px;
    font-size: 14px;
    display: flex;
  }
`;
const BlogHeroSection = () => {
  return (
    <Container>
      <Wrapper>
        <TitleHero>BrandAstra Blog</TitleHero>
        <ContentHero>
          Brandastra offers a powerful suite of social media tools that help
          businesses and agencies grow their reach, enhance brand visibility,
          and foster authentic connections with their audience
        </ContentHero>
      </Wrapper>
    </Container>
  );
};

export default BlogHeroSection;
